export class OfficeEquipmentModelInput {
    public name: string = '';
    public officeEquipmentBrandId: number = 0;
    public officeEquipmentTypeId: number = 0;
}
